import { initRelatedCaseStudiesCarousel } from "../component/related-case-studies-carousel.js";
import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initportfolioCarousel } from "../component/portfolio-carousel.js";
import { initCookieBar,initGooglePreferredSource,initDmcabadge } from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initContextMenu } from "../component/disable-rightclick.js";
import { initGlowWrapper } from "../component/glow.js";

initContextMenu();
initCookieBar();
initOfficeHoverReveal();
initRelatedCaseStudiesCarousel();
initGooglePreferredSource();
initDmcabadge();
initportfolioCarousel();
initMobileMenu();

document.addEventListener("DOMContentLoaded", () => {
    initGlowWrapper();
});